import React from 'react';
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import {observer} from "mobx-react";
import {BETTING_CONTAINER} from "../../../betting-container-consts";
import {BettingZoneDrawerMenuAccordionItems} from "./betting-zone.drawer-menu.accordion-items";
import {BettingZoneDrawerMenuItemArrow} from "./betting-zone.drawer-menu.item-arrow";
import {BettingZoneDrawerMenuItemLabels} from "./betting-zone.drawer-menu.item-labels";
import {Link} from "../../../../../core/components/link/link";
import classNames from "classnames";

export const BettingZoneDrawerMenuItem = observer(({controller, item, navigate, position, setIsMenuVisible, expandedItemId, setExpandedItemId}) => {
  const isPageItem: Boolean = item?.viewType === BETTING_CONTAINER.MENU_VIEW_TYPE.page;
  const isAccordionItem: Boolean = item?.viewType === BETTING_CONTAINER.MENU_VIEW_TYPE.accordion;

  const arrowProps = {
    controller,
    expandedItemId,
    item,
  }

  const accordionItemsProps = {
    controller,
    setIsMenuVisible,
    expandedItemId,
    setExpandedItemId,
    navigate,
    item
  }

  const handleClick = (e, item) => {
    e.stopPropagation()
    if(isPageItem) {
      navigate(item.id);
    } else if(isAccordionItem) {
      const id = item.id === expandedItemId ? null : item.id;

      setExpandedItemId(id);
    }

    return false
  };

  const onLinkClick = (e) => {
    controller.action(BETTING_CONTAINER.ACTION_TYPES.DRAWER_MENU.onNavigationClick, {
      label: item.displayLabel,
      menuLevel: item.level,
      pageUrl: item.url,
      position
    })

    e.stopPropagation()

    navigate(-1)
    if(expandedItemId !== null) {
      setExpandedItemId(null);
    }
    setIsMenuVisible(null)

    return true
  };

  const linkProps = {
    className: classNames(styles.item_link),
    model: !item.hasItems ? item.linkModel : null,
    onClick: (e) => item.hasItems ? handleClick(e, item) : onLinkClick(e),
  }

  return <>
    <li className={classNames(styles.item)} key={item.id}>
      <Link {...linkProps}>
        <BettingZoneDrawerMenuItemLabels item={item}/>
        <BettingZoneDrawerMenuItemArrow {...arrowProps}/>
      </Link>
    </li>
    <BettingZoneDrawerMenuAccordionItems {...accordionItemsProps}/>
  </>
});